import { render, staticRenderFns } from "./ArticleEditor.vue?vue&type=template&id=07680f4c&scoped=true"
import script from "./ArticleEditor.vue?vue&type=script&lang=js"
export * from "./ArticleEditor.vue?vue&type=script&lang=js"
import style0 from "./ArticleEditor.vue?vue&type=style&index=0&id=07680f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07680f4c",
  null
  
)

export default component.exports